if (!customElements.get('product-form')) {
  customElements.define('product-form', class ProductForm extends HTMLElement {
    constructor() {
      super();

      this.form = this.querySelector('form');
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
    }

    onSubmitHandler(evt) {
      evt.preventDefault();
      const submitButton = this.querySelector('[type="submit"]');
      if (submitButton.classList.contains('loading')) return; 

      this.handleErrorMessage();
      let cartNotification = document.querySelector('.cart-overlay-notification');

      submitButton.setAttribute('aria-disabled', true);
      submitButton.classList.add('loading');

      const config = fetchConfig('javascript');
      config.headers['X-Requested-With'] = 'XMLHttpRequest';
      config.body = JSON.stringify({
        ...JSON.parse(serializeForm(this.form))
      });

      fetch(`${routes.cart_add_url}`, config)
        .then((response) => response.json())
        .then((response) => {
          if (response.status) {
            this.handleErrorMessage(response.description);
            return;
          }

          cartNotification.classList.add('active');
          cartNotification.addEventListener('animationend', () => {
            cartNotification.classList.remove('active');
          }, {once: true});
          updateCartItemsCount();
        })
        .catch((e) => {
          console.error(e);
        })
        .finally(() => {
          submitButton.classList.remove('loading');
          submitButton.removeAttribute('aria-disabled');
        });
    }

    handleErrorMessage(errorMessage = false) {
      this.errorMessageWrapper = this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
      this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

      this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

      if (errorMessage) {
        this.errorMessage.textContent = errorMessage;
      }
    }
  });

  function updateCartItemsCount() {
    const headerCartIcon = document.querySelector('#cart-icon-bubble');
    const cartItemCount = headerCartIcon.querySelector('.cart-count-bubble');
    if (cartItemCount) {
      let currentCount = parseInt( cartItemCount.querySelector('span[aria-hidden="true"]').textContent );
      let newCount = currentCount + 1;
      cartItemCount.querySelector('span[aria-hidden="true"]').textContent = newCount;
      cartItemCount.querySelector('span.visually-hidden').textContent = newCount + ' items';
    } else {
      console.log('create counter')
      let counterElement = document.createElement('div');
      counterElement.classList.add('cart-count-bubble');
      counterElement.innerHTML = `<span aria-hidden="true">1</span><span class="visually-hidden">1 item</span>`;
      headerCartIcon.append(counterElement);
    }
  }
}